import {UUID_NULL} from '../constants/defaultValues'
import {
  SET_STATION,
  SENDING_STATIONS_REQUEST,
  FETCH_STATIONS_SUCCESS,
  FETCH_STATIONS_FAILURE,
  SENDING_STATION_UPDATE,
  //UPDATE_STATION_SUCCESS,
  UPDATE_STATION_FAILURE,
  SENDING_STATION_DELETE,
  //DELETE_STATION_SUCCESS,
  DELETE_STATION_FAILURE
} from '../actions/constants'

let initialState = {
  currentStation: {
    ID: UUID_NULL,
    Name: 'default'
  },
  stations: [],
  fetching: false,
  error: ''
}

const station = (state = initialState, action) => {
  switch (action.type) {
    case SET_STATION:
      return {
        ...state,
        currentStation: action.newStationState
      }
    case SENDING_STATIONS_REQUEST:
    case SENDING_STATION_UPDATE:
    case SENDING_STATION_DELETE:
      return {
        ...state,
        fetching: action.sending
      }
    case FETCH_STATIONS_SUCCESS:
      return {
        ...state,
        stations: action.stations
      }
    case FETCH_STATIONS_FAILURE:
      return {
        ...state,
        error: action.error
      }
    case UPDATE_STATION_FAILURE:
      return {
        ...state,
        error: action.error
      }
    case DELETE_STATION_FAILURE:
      return {
        ...state,
        error: action.error
      }
    default:
      return state
  }
}

export default station



// WEBPACK FOOTER //
// ./src/reducers/station.js